import { ListItemNode, SerializedListItemNode } from '@lexical/list';
import { EditorConfig, NodeKey } from 'lexical';

export type SerializedCustomListItemNode = SerializedListItemNode & {
  __blockId?: string;
  Modified?: 'true' | 'false' | 'added' | 'removed';
};

export class CustomListItemNode extends ListItemNode {
  __blockId?: SerializedCustomListItemNode['__blockId'];
  Modified?: SerializedCustomListItemNode['Modified'];

  static getType(): string {
    return 'listitem';
  }

  static clone(node: CustomListItemNode): CustomListItemNode {
    return new CustomListItemNode(node.getValue(), node.getChecked(), node.__blockId, node.Modified, node.__key);
  }

  constructor(value?: number, checked?: boolean, __blockId?: SerializedCustomListItemNode['__blockId'], Modified?: SerializedCustomListItemNode['Modified'], key?: NodeKey) {
    super(value, checked, key);

    this.__blockId = __blockId;
    this.Modified = Modified;
  }

  exportJSON(): SerializedCustomListItemNode {
    const json = super.exportJSON() as SerializedCustomListItemNode;
    if (this.__blockId) {
      json.__blockId = this.__blockId;
    }
    if (this.Modified !== undefined) {
      json.Modified = this.Modified;
    }
    return json;
  }

  static importJSON(serializedNode: SerializedCustomListItemNode): CustomListItemNode {
    const node = new CustomListItemNode(
      serializedNode.value,
      serializedNode.checked,
      serializedNode.__blockId,
      serializedNode.Modified
    );

    // Preserve formatting
    node.setFormat(serializedNode.format || '');
    node.setDirection(serializedNode.direction || null);
    node.setIndent(serializedNode.indent || 0);
    return node;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);

    if (this.__blockId) {
      dom.setAttribute('data-block-id', this.__blockId);
    }

    if (this.Modified === 'true') {
      dom.classList.add('modified-block', 'true');
    } else if (this.Modified === 'added') {
      dom.classList.add('modified-block', 'added');
    } else if (this.Modified === 'removed') {
      dom.classList.add('modified-block', 'removed');
    }

    return dom;
  }

  static importDOM(): Record<string, any> | null {
    return {
      li: () => ({
        conversion: () => ({ node: new CustomListItemNode() }),
        priority: 1,
      }),
    };
  }
}